// Payment Store

const state = {
  paymentLocale: '',
  paymentMethods: [],
  pending: false,
  pendingData: false,
  dataErrors: {},
  adyenConfig: null,
  amazonPayConfig: null,
  activePaymentMethod: null,
}

const getters = {
  isPending: ({ pending }) => pending,
}

const actions = {
  getPaymentMethods({ commit }, provider = 'all') {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items.createItem('payments.payment_methods', { provider }).then(({ data }) => {
        commit('SET_PAYMENT_METHODS', data.paymentMethods)
        commit('SET_PAYMENT_LOCALE', data.locale)
        commit('SET_PENDING', false)
        resolve()
      }).catch((err) => {
        commit('SET_PENDING', false)
        resolve() // Resolve so callers don't get unhandled rejection; Adyen simply won't be available
      })
    })
  },
  updatePaymentService({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.createItem('carts.mine.payment', { payment: payload }).then(response => {
        commit('SET_ACTIVE_SERVICE', payload)
        commit('SET_PENDING')
        resolve()
      }).catch((err) => {
        commit('SET_PENDING', false)
        resolve() // Resolve so callers don't get unhandled rejection; Adyen simply won't be available
      })
    })
  },
  updatePaymentData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING_DATA')
      this.api.items.createItem('carts.mine.payment', { ...payload }).then(response => {
        commit('SET_PENDING_DATA')
        commit('CLEAR_DATA_ERROR')
        resolve()
      }).catch(({ data }) => {
        commit('SET_PENDING_DATA')
        commit('SET_DATA_ERROR', data.errors)
      })
    })
  },
  getAdyenConfig({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING', true)
      this.api.items.getItem('payments.adyen_payment_config?type=dropin').then(({ data }) => {
        commit('SET_ADYEN_CONFIG', data)
        commit('SET_PENDING', false)
        resolve()
      }).catch(err => {
        commit('SET_PENDING', false)
        reject()
      })
    })
  },
  getAmazonPayConfig({ commit }) {
    console.log('####getAmazonPayConfig')
    return new Promise((resolve, reject) => {
      commit('SET_PENDING', true)
      this.api.items.getItem('payments.amazon_payment_config')
        .then(({ data }) => {
          console.log('####getAmazonPayConfig: response', data)
          commit('SET_AMAZON_PAY_CONFIG', data)
          commit('SET_PENDING', false)
          resolve()
        })
        .catch((err) => {
          console.log('####getAmazonPayConfig: error', err)
          commit('SET_PENDING', false)
          resolve() // Resolve so callers don't get unhandled rejection; Amazon Pay simply won't be available
        })
    })
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  SET_PENDING_DATA: state => {
    state.pendingData = !state.pendingData
  },
  CLEAR_DATA_ERROR: state => {
    state.dataErrors = {}
  },
  SET_DATA_ERROR: (state, errors) => {
    state.dataErrors = errors
  },
  SET_PAYMENT_LOCALE: (state, payload) => {
    state.paymentLocale = payload
  },
  SET_PAYMENT_METHODS: (state, payload) => {
    state.paymentMethods = payload
  },
  SET_ACTIVE_PAYMENT_METHOD: (state, payload) => {
    state.activePaymentMethod = payload
  },
  SET_ADYEN_CONFIG: (state, payload) => {
    const allowedCardNetworks = state.adyenConfig?.allowedCardNetworks || {}
    const selectedPaymentMethod = window.checkoutData?.paymentMethod
    if (selectedPaymentMethod && payload.allowedCardNetworks) {
      allowedCardNetworks[selectedPaymentMethod] = payload.allowedCardNetworks
    }
    payload.allowedCardNetworks = allowedCardNetworks
    state.adyenConfig = payload
  },
  SET_AMAZON_PAY_CONFIG: (state, payload) => {
    state.amazonPayConfig = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
